const TripDetailParser = {};
TripDetailParser.getTripDetailParser = (res) => {
  if (!res) {
    return {};
  }


  if (res) {
   const data = res?.result
    return data;
  }
};  



export { TripDetailParser };